import { configureCompat } from 'vue'

/*
TODO: Those are warnings added by the vue compatibility layer to this project.
To fully migrate to Vue3:
- remove one of the lines below
- navigate in the project until you see a matching warning
- fix the component triggering the warning
- if the warning disappears, to the same with the following line
- if there is still a warning, keep trying to fix it

There may be other "configureCompat" options in "vue.config.js" and in individual components
*/

/**
 * Configure Vue3 compatibility
 */
configureCompat({
  GLOBAL_MOUNT: 'suppress-warning',
  GLOBAL_PROTOTYPE: 'suppress-warning',
  GLOBAL_PRIVATE_UTIL: 'suppress-warning',
  WATCH_ARRAY: 'suppress-warning',
  COMPONENT_V_MODEL: 'suppress-warning',
  RENDER_FUNCTION: 'suppress-warning',
  INSTANCE_EVENT_EMITTER: 'suppress-warning',
  OPTIONS_BEFORE_DESTROY: 'suppress-warning',
  INSTANCE_ATTRS_CLASS_STYLE: 'suppress-warning',
  ATTR_FALSE_VALUE: 'suppress-warning',
  TRANSITION_GROUP_ROOT: 'suppress-warning',
  CUSTOM_DIR: 'suppress-warning',
  INSTANCE_LISTENERS: 'suppress-warning',
  COMPONENT_ASYNC: 'suppress-warning',
})
